<script>
import { get, invokeArgs, isFunction } from 'lodash/fp'
import Vue from 'vue'

const NotesTableIcon = () => import('../Notes/NotesTableIcon') // eslint-disable-line
const TableCellFraction = () => import('../TableCellFraction') // eslint-disable-line
const TableCellBoolean = () => import('../TableCellBoolean') // eslint-disable-line
const TableCellLink = () => import('../TableCellLink') // eslint-disable-line

export default {
  props: {
    itemID: {
      type: String,
      required: true
    },
    itemGetter: {
      type: String,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    perimeter: {
      type: String
    },
    uid: {
      type: String
    },
    noUnread: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    selected: {}
  },
  computed: {
    item () {
      return this.$store.getters[this.itemGetter](this.itemID)
    }
  },
  methods: {
    edit () {
      this.$emit('edit')
    },
    clicked (e) {
      // console.log('clicked', e)
      const { path, target } = e
      // console.log('path: ', path)
      const isSelectCell = path.findIndex(n => {
        // console.log('n', n)
        // console.log('n.classList', n.classList)
        return n.classList && n.classList.contains('select__cell')
      }) >= 0

      console.log('isSelectCell', isSelectCell)
      if (isSelectCell) {
        this.$emit('update:selected', !this.selected)
        e.preventDefault()
        e.stopPropagation()
        return null
      }

      const isLinkCell = target && target.tagName.toLowerCase() === 'a' && path.findIndex(n => {
        // console.log('n', n)
        // console.log('n.classList', n.classList)
        return n.classList && n.classList.contains('cell--link')
      }) >= 0
      if (isLinkCell) {
        e.stopPropagation()
        return null
      }

      const isActionsCell = path.findIndex(n => {
        // console.log('n', n)
        // console.log('n.classList', n.classList)
        return n.classList && n.classList.contains('table__actions')
      }) >= 0
      if (isActionsCell) {
        e.preventDefault()
        e.stopPropagation()
        return null
      }

      // console.log('selected: ', this.selected)
      if (!this.selected) {
        this.$emit('tap')
        e.preventDefault()
        e.stopPropagation()
        return null
      }
    }
  },
  render (h) {
    const directives = [
      {
        name: 'hammer',
        arg: 'press',
        value: (e) => {
          // console.log('onPress row: ', e)
          // console.log('this: ', this)
          this.$emit('press')
          this.$emit('update:selected', !this.selected)
        }
      }
    ]

    // console.log('render context: ', context)
    const item = this.item
    const headers = this.headers
    const dense = this.dense

    const uid = this.uid
    const unRead = this.noUnread
      ? false
      : item.readBy
        ? !item.readBy[uid]
        : true

    const tableCells = headers.map(header => {
      const value = get(header.value)(item)

      // Actions Cell
      if (header.text === 'Actions') {
        // Custom render function for that Cell
        if (header.render && isFunction(header.render)) {
          const self = this
          return invokeArgs('render')([item, h, self])(header)
        }

        const editButton = this.canEdit ? (
          <v-btn
            icon
            class="mx-0 my-0"
            flat
            onClick={ this.edit }
            small={ dense }
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        ) : null

        return <td
          class={{ 'table__actions table__actions--cell': true, 'px-2': true }}
        >
          <NotesTableIcon docId={this.itemID} dense={dense}/>
          {editButton}
        </td>
      }

      // Custom render function for that Cell
      if (header.render && isFunction(header.render)) {
        return invokeArgs('render')([value])(header)
      }

      // Standard custom components
      switch (header.render) {
        case 'fraction':
          return <TableCellFraction value={value} unit={header.unit} onClick/>
        case 'boolean':
          return <TableCellBoolean value={value}/>
        case 'link':
          return <TableCellLink value={value}/>
        default:
          break
      }

      // cells that require a specific filter
      if (header.filter) {
        // console.log('header: ', header)
        // console.log('header.filter: ', header.filter)
        // console.log('header.filterArgs: ', header.filterArgs)

        return header.filterArgs
          ? <td domPropsInnerHTML={Vue.filter(header.filter)(value)}></td>
          : <td domPropsInnerHTML={Vue.filter(header.filter)(value)}></td>
      }

      // generic cells with raw output
      if (value) return <td domPropsInnerHTML={value}></td>

      // No value found
      return <td></td>
    })

    const checkboxCell = this.$vuetify.breakpoint.smAndUp && (
      <td class="select__cell">
        <v-checkbox
          class="report__select"
          inputValue={this.selected}
          primary
          hide-details
        ></v-checkbox>
      </td>
    )

    return (
      <tr
        class={{
          'table__row': true,
          'table__row--unread': unRead,
          'table__row--dense': dense
        }}
        key={this.itemID}
        active={this.selected}
        nativeOnClick={this.clicked}
        onClick={this.clicked}
        {...{ directives }}
      >
        {checkboxCell}
        {tableCells}
      </tr>
    )
  }
}
</script>

<style lang="stylus">
$denseRowHeight = 32px

.table__row

  &&--unread > *
    font-weight: bold !important

  &&--dense
    td
      height: $denseRowHeight

  &:hover
    cursor: pointer

</style>
